<template>
    <header>
        <div class="header_main">
            <div>
                <a href="/" target="_blank" class="logo">
                    <img src="../assets/logo.png" alt="玖寻导航" width="32px" height="32px"/>玖寻导航
                </a>
            </div>
            <div class="search">
                <div style="margin-right: 5px;">
                    <el-select
                        placeholder=""
                        @change="changeSearchSite"
                        v-model="selectedSite"
                        ref="refSelect" style="width: 100px;height: 32px;padding:0px">
                        <el-option
                            v-for="(item, index) in searchSiteItems"
                            :key="index"
                            :label="item.label"
                            :value="item.value" style="display: flex;flex-direction: column;">
                            <div>
                                <img :src="item.url" style="vertical-align: top;width: 24px; height: 24px;padding: 5px 5px 0px 0px;">{{item.value}}
                            </div>
                        </el-option>
                    </el-select>
                </div>
                <div>
                    <input type="text" placeholder="" @keyup.enter="handleSearch" v-model="keyword">
                </div>
                <div>
                    <button @click="search">搜 索</button>
                </div>
            </div>
            <div class="nav_bar">
                <div>
                    <a href="/hots" target="_blank">热搜热榜</a>
                </div>
                <div>
                    <a href="/sitemap" target="_blank">网站地图</a>
                </div>
                <div>
                    <a href="/search" target="_blank">站内搜索</a>
                </div>
            </div>
        </div>
        
    </header>
</template>

<script>
    export default {
        name: 'HeaderBar',
        data(){
            return{
                keyword:"",
                searchSiteUrls:[
                    {"name":"百度","url":"https://www.baidu.com/s?wd="},
                    {"name":"谷歌","url":"https://www.google.com/search?q="},
                    {"name":"必应","url":"https://cn.bing.com/search?q="},
                    {"name":"搜狗","url":"https://www.sogou.com/web?query="},
                    {"name":"360","url":"https://www.so.com/s?q="},
                    {"name":"站内","url":"/search?q="},
                ],
                selectedSite:'百度',
                searchSiteItems:[
                    {url: require('@/assets/search_icon/baidu.png'),value: '百度',label: ''},
                    {url: require('@/assets/search_icon/google.png'),value: '谷歌',label: ''},
                    {url: require('@/assets/search_icon/bing.png'),value: '必应',label: ''},
                    {url: require('@/assets/search_icon/sogou.png'),value: '搜狗',label: ''},
                    {url: require('@/assets/search_icon/360.png'),value: '360',label: ''},
                    {url: require('@/assets/search_icon/logo.png'),value: '站内',label: ''},
                ],
            }
        },mounted () {
            if (this.$route.path === '/search') {
                this.changeSearchSite("站内")
                this.selectedSite='站内'
            } else {
                this.changeSearchSite("百度")
                this.selectedSite='百度'
            }
        },
        methods:{
            search(){
                var url = "https://www.baidu.com/s?wd=";
                for(let index in this.searchSiteUrls) {
                    let item = this.searchSiteUrls[index];
                    if(item.name==this.selectedSite){
                        url = item.url
                    }
                }
                if (this.$route.path === '/search' && this.selectedSite === '站内') {
                    const param = this.keyword
                    this.$emit('doSearch',param);
                }else{
                    window.open(url+this.keyword, '_blank')
                }
            },
            changeSearchSite (val) {
                for(let index in this.searchSiteItems) {
                    let item = this.searchSiteItems[index];
                    let value = item.value;
                    if( val === value ) {
                        this.$refs.refSelect.$el.children[0].children[0].setAttribute('style',"background:url("+ item.url +") no-repeat;background-position: top 5px center;background-position: right 32px center;width:50px;height:32px;background-size: 24px 24px;padding-left: 32px;");
                    }
                }
            },
            handleSearch(){
                this.search();
            }
        }
    }
</script>